import { useAct } from 'DashboardUser/store'
import useShouldShowCards from 'DashboardUser/hooks/useShouldShowCards'

export default function ViewToggleButton() {
  const act = useAct()
  const shouldShowCards = useShouldShowCards()

  return (
    <button
      className='button secondary view-toggle-button'
      onClick={() => act.local.upsert({ viewMode: shouldShowCards ? 'table' : 'cards' })}
      aria-label="Toggle view"
    >
      {shouldShowCards ? <SvgIconsTableChart /> : <SvgIconsViewAgenda />}
    </button>
  )
}
